import iconPoint from "../../images/point.svg";
import _ from "lodash";
import ymaps from '../../../node_modules/ymaps/dist/ymaps.esm.js';
import {getRegion} from "../../js/helpers";

export class DistanceMap {

  constructor(data) {
    this.mapEl = data.element;
    this.CITY = data.CITY;
    this.LOCATION = data.LOCATION;
    this.addressFrom = data.addressFrom;
    this.coordinates = data.coordinates;
    this.routeObjects = false;
  }

  init() {
    if (this.mapEl && this.mapEl.classList.contains('inited')) return;
    ymaps.load('https://api-maps.yandex.ru/2.1/?apikey=109e4b66-0503-4da1-b84c-bc91501ea5fa&lang=ru_RU&mode=debug').then(maps => {
      this.maps = maps;
      this.myMap = new maps.Map(this.mapEl, {
        center: this.coordinates,
        zoom: 19,
        controls: [],
      });
      this.myMap.controls.add('zoomControl', {
        size: 'small',
        position: {
          right: '20px',
          top: '100px'
        }
      });
      this.myMap.controls.add('geolocationControl', {
        position: {
          right: '20px',
          top: '180px'
        }
      });

      this.createRoutePanel();
      this.initRoute();
      this.events();
      this.mapEl.classList.add('inited');
    })
  }

  createRoutePanel() {
    // Создадим панель маршрутизации.
    this.routePanelControl = new this.maps.control.RoutePanel({
      options: {
        showHeader: false,
        title: 'Расчёт доставки'
      }
    });
    // Пользователь сможет построить только автомобильный маршрут.
    this.routePanelControl.routePanel.options.set({
      allowSwitch: false,
      types: {auto: true}
    });
    // задаем неизменяемую точку "откуда".
    this.routePanelControl.routePanel.state.set({
      fromEnabled: false,
      toEnabled: false,
      from: this.addressFrom,
    });
    this.myMap.controls.add(this.routePanelControl);
  }

  events() {
    document.addEventListener('order-delivery-geocode', e => this.setToAddress(e));
  }

  setToAddress(e) {
    this.routePanelControl.routePanel.state.set({
      to: e.detail.join(', ')
    });
  }

  createRingRoadArea(location) {
    import('./json/ringRoad-' + location).then(module => {
      this.ringRoadPoligon = new this.maps.Polygon(module.coordinates);
      // Если мы не хотим, чтобы контур был виден, зададим соответствующую опцию.
      this.ringRoadPoligon.options.set('visible', false);
      // Чтобы корректно осуществлялись геометрические операции
      // над спроецированным многоугольником, его нужно добавить на карту.
      this.myMap.geoObjects.add(this.ringRoadPoligon);
    });
  }

  openErrorBaloon(errorText) {
    this.myMap.balloon.open(this.routeCoords[1], {
      contentHeader: 'Уточните Ваш адрес.',
      contentBody: `<p>${errorText}</p>`
    });
  }

  initRoute() {
    // Получим ссылку на маршрут.
    this.multiRoutePromise = this.routePanelControl.routePanel.getRouteAsync();
    this.multiRoutePromise.then(route => {
      // Зададим максимально допустимое число маршрутов, возвращаемых мультимаршрутизатором.
      route.model.setParams({results: 1}, true);

      route.options.set({
        wayPointStartIconLayout: "default#image",
        wayPointStartIconImageHref: iconPoint,
        wayPointStartIconImageSize: [30, 30],
        wayPointStartIconImageOffset: [-15, -15],
        visible: false
      });

      const requestSuccess = () => {
        const activeRoute = route.getActiveRoute();
        this.myMap.balloon.close();

        if (activeRoute) {
          this.routeCoords = [route.getWayPoints().get(0).geometry.getCoordinates(), route.getWayPoints().get(1).geometry.getCoordinates()];
          this.addressToDetailed = route.getWayPoints().get(1).properties.getAll();
          const toAdministrativeAreaName = this.addressToDetailed.geocoderMetaData.AddressDetails.Country.AdministrativeArea.AdministrativeAreaName;

          if (toAdministrativeAreaName !== this.CITY && toAdministrativeAreaName !== getRegion(this.CITY)) {
            this.openErrorBaloon('Нет доставки в этот населенный пункт.');

            const LocalityName = this.addressToDetailed.geocoderMetaData.AddressDetails.Country.AdministrativeArea.SubAdministrativeArea.Locality.LocalityName;
            document.dispatchEvent(new CustomEvent("order-address-error", {
              'detail': {
                field: 'CITY',
                value: LocalityName
              }
            }));
          } else {
            document.dispatchEvent(new CustomEvent("order-address-city-ok"));
            if (this.addressToDetailed.geocoderMetaData.kind === 'house') {
              if (!this.ringRoadPoligon) {
                this.createRingRoadArea(this.LOCATION);
              }
              this.calcRouteLength(route);
            } else
              this.openErrorBaloon('Адрес должен содержать улицу и номер дома.');
          }
        }
      };

      // Повесим обработчик на событие построения маршрута.
      route.model.events.add('requestsuccess', _.debounce(requestSuccess, 800));
    });
  }

  calcRouteLength() {
    if (this.routeObjects)
      this.routeObjects.removeFromMap(this.myMap);

    this.maps.route(this.routeCoords).then(res => {
        // Объединим в выборку все сегменты маршрута.
        let pathsObjects = this.maps.geoQuery(res.getPaths());
        let edges = [];

        let wayPoints = res.getWayPoints();

        wayPoints.get(0).options.set('visible', false);

        // Переберем все сегменты и разобьем их на отрезки.
        pathsObjects.each(function (path) {
          let coordinates = path.geometry.getCoordinates();
          for (let i = 1, l = coordinates.length; i < l; i++) {
            edges.push({
              type: 'LineString',
              coordinates: [coordinates[i], coordinates[i - 1]]
            });
          }
        });


        //Иконка для офиса (точки отправления)
        let veryBerryLabPlacemark = new this.maps.Placemark(this.routeCoords[0], {
          hintContent: 'Very Berry LAB',
          balloonContent: 'Very Berry LAB'
        }, {
          iconLayout: 'default#image',
          iconImageHref: iconPoint,
          iconImageSize: [30, 30],
          iconImageOffset: [-15, -15]
        });

        this.myMap.geoObjects.add(veryBerryLabPlacemark);

        // Создадим новую выборку, содержащую:
        // - отрезки, описываюшие маршрут;
        // - начальную и конечную точки;
        // - промежуточные точки.
        let routeObjects = this.routeObjects = this.maps.geoQuery(edges)
          .add(wayPoints)
          .add(res.getViaPoints())
          .setOptions('strokeWidth', 3)
          .addToMap(this.myMap);

        // Найдем все объекты, попадающие внутрь МКАД
        let objectsInMoscow = routeObjects.searchInside(this.ringRoadPoligon);

        // Найдем объекты, пересекающие МКАД
        let boundaryObjects = routeObjects.searchIntersect(this.ringRoadPoligon);

        // Раскрасим в разные цвета объекты внутри, снаружи и пересекающие МКАД
        boundaryObjects.setOptions({
          strokeColor: '#06ff00',
        });

        objectsInMoscow.setOptions({
          strokeColor: '#0010ff',
          preset: 'islands#blueDotIcon',
        });

        // Объекты за пределами МКАД получим исключением полученных выборок из исходной.
        let outOfArea = routeObjects.remove(objectsInMoscow).remove(boundaryObjects).setOptions({
          strokeColor: '#ff0005',
          preset: 'islands#blueDotIcon',
        });

        let routeLength = 0;

        const cb = routeLength => {
          document.dispatchEvent(new CustomEvent("order-address", {
            'detail': {
              routeLength,
              addressToDetailed: this.addressToDetailed
            }
          }));
        };

        if (!outOfArea._objects.length) {
          cb(routeLength);

          return;
        }

        let fromMKADcoords = outOfArea.get(0).geometry.getCoordinates()[1];

        let toCoords = this.routeCoords[1];

        this.maps.route([fromMKADcoords, toCoords]).then(function (fromMKADtoDest) {
          routeLength = (fromMKADtoDest.getLength() / 1000).toFixed(2);

          cb(routeLength);
        });
      }
    );
  }
}
